const Pusher = require("pusher-js");

export const pusher = new Pusher("9e7a9c6b742095d3d3ea", {
  cluster: "eu",
  forceTLS: true,
  authEndpoint: "http://localhost:3000/pusher/auth"
});

export const channel = pusher.subscribe("pilote-immo-event");
